var get = require("object-path").get;

/**
 * CookieYes CMP.
 *
 * @param  {Object}  config  The app config
 */
module.exports = function(config) {
    var firstScript = document.getElementsByTagName("script")[0],
        script;

    // Delete subdomain cookies to prevent redirect loop
    if (get(config, "cookieYes.deleteSubdomainCookies", false)) {
        deleteCookieYesConsentOnSubdomains();
    }

    script       = document.createElement("script");
    script.async = true;
    script.id    = "cookieyes";
    script.type  = "text/javascript";
    script.src   = config.cookieYes.url;

    script.onload  = function() {
        document.dispatchEvent(new CustomEvent("cookieyes_tag_loaded"));
    };

    script.onerror = function(error) {
        document.dispatchEvent(new CustomEvent("cookieyes_tag_error", {
            detail: error.target.src + " didn't load correctly."
        }));
    };

    if (script.src && firstScript) {
        firstScript.parentNode.insertBefore(script, firstScript);
    }
};

/**
 * Force invalidate any subdomain-registered cookie-yes cookies.
 *
 * @param  {Object}  config  The app config
 */
function deleteCookieYesConsentOnSubdomains() {
    var expirationDate,
        expires,
        domain;

    expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() - 24 * 60 * 60 * 1000);
    expires        = "expires=" + expirationDate.toUTCString();

    domain = window.location.hostname;

    document.cookie = "cookieyes-consent=; " + expires + "; path=/; domain=" + domain + ";";
}
